export default __webpack_public_path__ + "static/media/ic_twitter.9f35b403.svg";